import { http, HttpResponse } from 'msw';
import { userFactory } from '@trukt/factories/userFactory';
import { accountFactory } from '@trukt/factories/accountFactory';
import { contactFactory } from '@trukt/factories/contactFactory';
import { mockTruktTmsApiUrl } from '../../../../../../mocks';
import { JobDispatchCarrierGetResponse } from './JobDispatchCarrierService';

export const jobDispatchCarrierServiceHandlers = [
  http.get(mockTruktTmsApiUrl('/job/:jobGuid/dispatch/carrier'), () => {
    const response: JobDispatchCarrierGetResponse = {
      dispatcher: userFactory.build(),
      vendor: accountFactory.build(),
      vendorAgent: contactFactory.build(),
    };

    return HttpResponse.json(response);
  }),
];
